import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "incoming-message" }, null, -1)
const _hoisted_2 = { class: "hushline-reply-options" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Reply ")

import { BrainViewModel } from '../../../../ecs/brains/Brain';
import IconComponent from '../../../icon/IconComponent.vue';
import Icon from '@/components/icon/Icon';
import ButtonComponent from '../../../ButtonComponent.vue';
import BuildableDialogueBodyWidget from '../buildableDialog/BuildableDialogueBodyWidget.vue';
import { computed, ref, Ref } from 'vue';
import { BuildableDialogItem } from '../../../../models/BuildableDialogItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderedCheckboxComponent',
  props: {
    brain: null,
    timeOnActiveCall: null
  },
  emits: ['submit', 'hangup'],
  setup(__props: any, { emit }) {





const builtDialogMessage: Ref<BuildableDialogItem[]> = ref([]);

// const secondsForMessageToAppear = 5;
const failed = false;
// setTimeout(function fail() {
//   failed = true;
// }, secondsForMessageToAppear * 1000);

const failingResponse = 'Declined call';

const builtMessageBroadcast = computed(() => {
  return builtDialogMessage.value.map((item) => item.textValue).join(' ');
});

const reply = () => {
  if (failed) {
    emit('submit', failingResponse);
  } else {
    emit('submit', builtMessageBroadcast.value);
  }
};

function addDialogToBuiltDialogMessage(dialogItem: BuildableDialogItem) {
  builtDialogMessage.value.push({ ...dialogItem });
}

function removeDialog(index: number) {
  builtDialogMessage.value.splice(index, 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BuildableDialogueBodyWidget, {
        "available-dialog": 
          __props.brain.options
            .filter((option) => option.dialog)
            .map((edge) => {
              return {
                textValue: edge.dialog
              };
            })
        ,
        builtDialogMessage: builtDialogMessage.value,
        onAddDialog: addDialogToBuiltDialogMessage,
        onClear: _cache[1] || (_cache[1] = ($event: any) => (builtDialogMessage.value = [])),
        onRemoveDialog: removeDialog
      }, {
        reply: _withCtx(() => [
          _createVNode(ButtonComponent, {
            "color-type": "tertiary",
            size: "large",
            class: "flex mb-2 ml-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (builtDialogMessage.value.length > 0 && reply())),
            disabled: builtDialogMessage.value.length == 0
          }, {
            default: _withCtx(() => [
              _createVNode(IconComponent, {
                icon: _unref(Icon).SEND_ARROW,
                class: "mr-2"
              }, null, 8, ["icon"]),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["available-dialog", "builtDialogMessage"])
    ])
  ]))
}
}

})